import {
  INVITATION_GET_SUCCESS,
  INVITATION_CREATE_SUCCESS,
  INVITATION_UPDATE_SUCCESS,
  INVITATION_UPDATE_ERROR,
  INVITATION_DELETE_SUCCESS,
  INVITATION_DELETE_ERROR,
  INVITATION_LIST_GET_SUCCESS,
  INVITATION_LIST_GET_IN_PROGRESS,
  INVITATION_LIST_GET_REQUEST,
  INVITATION_LIST_GET_ERROR,
} from 'src/store/invitation/actions'
import { getIdsFromList, getByIdFromList } from 'src/utils/store'
import { USER_DELETE_SUCCESS } from 'src/store/user/actions'

export const getInitialState = {
  status: null,
  data: null,
  error: null,
  byId: null,
  statusById: null,
  errorById: null,
}

export const reducer = (state = getInitialState, action) => {
  const { type, payload, error } = action
  const { uuid } = typeof payload === 'string' ? payload : payload || {}
  switch (type) {
    case INVITATION_LIST_GET_REQUEST:
    case INVITATION_LIST_GET_IN_PROGRESS:
    case INVITATION_LIST_GET_ERROR:
      return {
        ...state,
        status: type,
      }
    case INVITATION_LIST_GET_SUCCESS:
      return {
        ...state,
        status: type,
        data: getIdsFromList(payload),
        byId: getByIdFromList(payload),
        statusById: getIdsFromList(payload).reduce(
          (status, id) => ({
            ...status,
            [id]: type,
          }),
          {}
        ),
        errorById: {},
      }
    case INVITATION_GET_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: data.indexOf(uuid) > -1 ? data : [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case INVITATION_CREATE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case INVITATION_UPDATE_SUCCESS: {
      const { data, byId, statusById, errorById, ...restState } = state
      const { uuid } = payload
      const newState = {
        ...restState,
        data,
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: undefined,
        },
      }
      return newState
    }
    case INVITATION_UPDATE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: error,
        },
      }
    }
    case INVITATION_DELETE_SUCCESS: {
      const { data, byId, statusById, errorById, ...restState } = state
      return {
        ...restState,
        data: data.filter((id) => id !== uuid),
        byId: {
          ...byId,
          [uuid]: undefined,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: undefined,
        },
      }
    }
    case INVITATION_DELETE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: error,
        },
      }
    }
    case USER_DELETE_SUCCESS: {
      const { data, byId, statusById, errorById, ...restState } = state
      const userInvitationUuid = data.find(
        (uuid) => byId[uuid].user && byId[uuid].user.uuid === payload.uuid
      )
      return {
        ...restState,
        data: data.filter((uuid) => uuid !== userInvitationUuid),
        byId: {
          ...byId,
          [userInvitationUuid]: undefined,
        },
        statusById: {
          ...statusById,
          [userInvitationUuid]: type,
        },
        errorById: {
          ...errorById,
          [userInvitationUuid]: undefined,
        },
      }
    }
    default:
      return state
  }
}

export default reducer
